import { UserInformation } from '../../models/api';
import { LoginStatesOptions } from '../../models/api-client';
import { Token } from '../../models/store';

export class TokenHelper {
    private static encrypted: string;
    private static decoded: string;
    private static userInfo: UserInformation

    static saveToken(token, url) {
        localStorage.setItem('TOKEN', token);
        this.encrypted = token;
        this.decoded = this.decodeToken();
        this.userInfo = {
            token: {
                appId: JSON.parse(this.decoded).AppId,
                osaId: JSON.parse(this.decoded).OsaId,
                customerNumber: JSON.parse(this.decoded).CustomerNumber,
                isCustomer: (JSON.parse(this.decoded).IsCustomer == 'True'),
                isCallCenterAdmin: (JSON.parse(this.decoded).IsCallCenterAdmin == 'True'),
                state: LoginStatesOptions[LoginStatesOptions[JSON.parse(this.decoded).State]],
                supportSelected: this.supportSelected(JSON.parse(this.decoded).KindOfSupport),
                kindOfSupport: this.kindOfSupportList(JSON.parse(this.decoded).KindOfSupport),
                dateExpired: JSON.parse(this.decoded).exp,
                debtorNumber: JSON.parse(this.decoded).DebtorNumber,
            } as Token,
            url: url,
        } as UserInformation;
    }

    static getUserInformation(): UserInformation {
        return this.userInfo;
    }

    private static decodeToken(): string {
        const base64Url = this.encrypted.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const decodedToken = decodeURIComponent(atob(base64).split('')
            .map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(''));
        return decodedToken;
    }

    private static kindOfSupportList(kindOfSupport: string): string[] {
        var separators = [',', ';'];
        kindOfSupport = kindOfSupport.replace(' ', '');
        return kindOfSupport.split(new RegExp(separators.join('|'), 'g'));
    }
    private static supportSelected(kindOfSupport: string): string {
        const kindSupport = this.kindOfSupportList(kindOfSupport);
        return kindSupport[0];
    }
    private static isValid(): boolean {
        const currentTime = new Date().getTime();
        const validToDate = this.userInfo.token.dateExpired * 1000;
        const check = currentTime < validToDate;
        return check;
    }

    static isExpired(): boolean {
        const isExpired = !this.isValid();
        if (isExpired) {
            localStorage.removeItem('TOKEN');
        }
        return isExpired;
    }

    static deleteToken() {
        localStorage.removeItem('TOKEN');
    }
}